import React from 'react'
import Map from '../../../../../../common/components/map'
import _ from 'lodash';
import { format } from '../../../../../../common/services/date.service';
import { Menu } from '@headlessui/react';

export default function JobComponent({ colorDecider, shippingStatusId, handleRejectOpen, handleMenuClose, handleShipmentStatusClick, back, jobDetails, getShippingType, getTransporterAgentName, setAnchorShipmentEl, ConvertMinutes, anchorShipmentEl }: any) {



  const originGps = jobDetails?.Message?.PickupInfo?.location?.gps;
  const destinationGps = jobDetails?.Message?.DeliveryInfo?.location?.gps;
  const image = require('../../../../../../assets/img/delivery.png')
  const latLongData: any = _.split(originGps, ',');
  return (
    <>

      <div className="flex flex-col items-center bg-white w-full px-5 overflow-auto h-auto pt-10 pb-10">


        {originGps && <div className="w-full px-5 text-gray-800">

          <div className="w-full">
            <Map
              lat={latLongData[0]}
              lng={latLongData[1]}
              height={'420px'}
              zoom={15}
              icon={image}
              showInfoWindow={false}
              isRouteDirection={true}
              originLocation={originGps}
              destinationLocation={destinationGps}
            />

          </div>
        </div>}

        <div className="w-full min-h-full flex justify-between flex-col md:flex-row">
          {jobDetails && <div className="px-5 w-full mt-10">
            <div className="mb-10">
              <h3 className="font-bold text-gray-600 text-xl">Order</h3>
            </div>
            <div className="mb-2 text-gray-400">
              <div><span className="text-gray-500 text-sm">Order ID:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.Message?.ShipmentInfo?.ShipmentId}</span></div>
              <div><span className="text-gray-500 text-sm">Transport Agents:</span><span className="text-gray-600 text-sm px-2">{getTransporterAgentName(jobDetails?.Message?.TransportAgentId)}</span></div>
              <div><span className="text-gray-500 text-sm">Status:</span><span className="text-gray-600 text-sm px-2">

              </span>
                <Menu as="div" className="relative text-left ">

                  <Menu.Button onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)}
                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white  ${colorDecider ? colorDecider : "bg-neutral-600"} `}
                  >
                    {getShippingType(shippingStatusId) || null}
                  </Menu.Button>

                  {anchorShipmentEl && (
                    <Menu.Items className="absolute fixed z-10 bg-white border border-gray-300 rounded shadow-lg  w-40 p-1">
                      <div className="px-1 py-1 ">
                        <Menu.Item>
                          <button
                            onClick={() => {
                              handleShipmentStatusClick(30);
                              handleMenuClose();
                            }}
                            className="p-2 hover:bg-gray-300  text-slate-950">

                            Order-picked-up											</button>
                        </Menu.Item>
                        <Menu.Item>
                          <button
                            onClick={() => {
                              handleShipmentStatusClick(50);
                              handleMenuClose();
                            }}
                            className="p-2 hover:bg-gray-300  text-slate-950 ">

                            Out-for-delivery										</button>
                        </Menu.Item>
                        <Menu.Item>
                          <button
                            onClick={() => {
                              handleShipmentStatusClick(60);
                              handleMenuClose();
                            }}
                            className="p-2 hover:bg-gray-300  text-slate-950">

                            Order-delivered										</button>
                        </Menu.Item>
                        <Menu.Item>
                          <button
                            onClick={() => {
                              handleShipmentStatusClick(79);
                              handleMenuClose();
                            }}
                            className="p-2 hover:bg-gray-300  text-slate-950 ">

                            RTO-Disposed										</button>
                        </Menu.Item>
                        <Menu.Item>
                          <button
                            onClick={() => {
                              handleShipmentStatusClick(80);
                              handleMenuClose();
                            }}
                            className="p-2 hover:bg-gray-300  text-slate-950 ">

                            RTO-Delivered										</button>
                        </Menu.Item>
                        <Menu.Item>
                          <button
                            onClick={() => {
                              handleRejectOpen()
                              handleMenuClose();
                            }}
                            className="p-2 hover:bg-gray-300  text-slate-950 ">

                            Cancel
                          </button>
                        </Menu.Item>

                      </div>
                    </Menu.Items>
                  )}
                </Menu>

              </div>
              <div><span className="text-gray-500 text-sm">Pickup time</span><span className="text-gray-600 text-sm px-2">{format(jobDetails?.Message?.ShipmentInfo?.ShippedDateUtc)}</span></div>
              <div><span className="text-gray-500 text-sm">Remaining Time</span><span className="text-gray-600 text-sm px-2">{ConvertMinutes(jobDetails?.Message?.ShipmentInfo?.RemainingDeliveryTime || 0)}</span></div>
            </div>

          </div>}
          <div className="px-5 w-full mt-10">
            <div className="mb-2">
              <h3 className="font-bold text-gray-600 text-xl">Pickup</h3>
            </div>
            {jobDetails?.Message?.PickupInfo && <div className="mb-2 text-gray-400">
              <div><span className="text-gray-500 text-sm">Code:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.Message?.ShipmentInfo?.PickupCode}</span></div>
              <div><span className="text-gray-500 text-sm">Name</span><span className="text-gray-600 text-sm px-2">{jobDetails?.Message?.PickupInfo?.person?.name}</span></div>
              <div><span className="text-gray-500 text-sm break-words">Address:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.Message?.PickupInfo?.location?.address?.building} , {jobDetails?.Message?.PickupInfo?.location?.address?.locality} ,  {jobDetails?.Message?.PickupInfo?.location?.address?.city} , {jobDetails?.Message?.PickupInfo?.location?.address?.country} , {jobDetails?.Message?.PickupInfo?.location?.address?.state} - {jobDetails?.Message?.PickupInfo?.location?.address?.area_code}</span></div>
              <div><span className="text-gray-500 text-sm">Contact:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.Message?.PickupInfo?.contact?.name}</span></div>
            </div>}
          </div>
          <div className="px-5 w-full mt-10">
            <div className="mb-2">
              <h3 className="font-bold text-gray-600 text-xl">Delivery</h3>
            </div>
            {jobDetails?.Message?.DeliveryInfo && <div className="mb-2 text-gray-400">
              <div><span className="text-gray-500 text-sm">Code:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.Message?.ShipmentInfo?.DeliveryCode}</span></div>
              <div><span className="text-gray-500 text-sm">Name</span><span className="text-gray-600 text-sm px-2">{jobDetails?.Message?.DeliveryInfo?.person?.name}</span></div>
              <div><span className="text-gray-500 text-sm break-words">Address:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.Message?.DeliveryInfo?.location?.address?.building} , {jobDetails?.Message?.DeliveryInfo?.location?.address?.locality} ,  {jobDetails?.Message?.DeliveryInfo?.location?.address?.city} , {jobDetails?.Message?.DeliveryInfo?.location?.address?.country} , {jobDetails?.Message?.DeliveryInfo?.location?.address?.state} - {jobDetails?.Message?.DeliveryInfo?.location?.address?.area_code}</span></div>
              <div><span className="text-gray-500 text-sm">Contact:</span><span className="text-gray-600 text-sm px-2">{jobDetails?.Message?.DeliveryInfo?.contact?.name}</span></div>
            </div>}
          </div>

        </div>
        <div className='flex w-full justify-end items-end h-20'>
          <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          >
            Back
          </button>
        </div>
      </div>

    </>
  )
}